import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
    path: '/resources',
    name: ' resources',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/resources/index',
    children: [
        {
            path: 'index',
            name: 'index',
            meta: {
                title: '音视频',
                keepAlive: false
            },
            component: resolve => require(['@/views/videoManage/Index.vue'], resolve),
        },
        {
            path: 'curriculum',
            name: "curriculumList",
            meta: {
                title: "课程",
                keepAlive: false
            },
            component: resolve => require(["@/views/curriculum/index.vue"], resolve),
        },
        {
            path: 'curriculum',
            meta: {
                title: '课程',
                keepAlive: false
            },
            component: Empty,
            children: [
                {
                    path: "assemblyCourse",
                    name: "assemblyCourse",
                    meta: {
                        title: "组课",
                        keepAlive: false
                    },
                    component: resolve => require(["@/views/curriculum/assemblyCourse.vue"], resolve)
                }
            ]
        }
    ]
}


